var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileChartLine = function SvgFileChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.6 7.5h1.8v9h-1.8zm3.6 3.6H17v5.4h-1.8zM8 12.9h1.8v3.6H8zm7.2-8.1h-9v14.4h12.6V8.4h-3.6zM4.4 3.893C4.4 3.4 4.802 3 5.3 3h10.8l4.5 4.5v12.594a.9.9 0 0 1-.894.906H5.294a.9.9 0 0 1-.894-.893z"
  })));
};
export default SvgFileChartLine;